import { Routes } from '@angular/router';
import { providers } from 'app/app.providers';
import { BoardButtonCallbackComponent } from 'app/trello/components/callbacks/board-button-callback/board-button-callback.component';
import { OauthCallbackComponent } from 'app/trello/components/callbacks/oauth-callback/oauth-callback.component';
import { CardChatComponent } from 'app/trello/components/pages/card-chat/card-chat.component';
import { ConfigurationComponent } from 'app/trello/components/pages/configuration/configuration.component';
import { HelpComponent } from 'app/trello/components/pages/help/help.component';
import { HomeComponent } from 'app/trello/components/pages/home/home.component';
import { OnboardingComponent } from 'app/trello/components/pages/onboarding/onboarding.component';
import { BoardSummaryReferenceComponent } from 'app/trello/components/pages/reports/board-summary-reference/board-summary-reference.component';
import { BoardSummaryComponent } from 'app/trello/components/pages/reports/board-summary/board-summary.component';
import { CardDetailsComponent } from 'app/trello/components/pages/reports/card-details/card-details.component';
import { MemberActivityComponent } from 'app/trello/components/pages/reports/member-activity/member-activity.component';
import { TimeTrackingComponent } from 'app/trello/components/pages/reports/time-tracking/time-tracking.component';
import { PageLayoutComponent } from 'app/trello/components/shared/page-layout/page-layout.component';
import { AuthenticationGuard } from 'app/trello/guards/authentication.guard';
import { IframeOriginGuard } from 'app/trello/guards/iframe-origin.guard';
import { environment } from 'environments/environment';

function lastSegment(
  path: string,
): string {

  const segments = path.replace(/\/+$/, '').split('/');

  return segments[segments.length - 1];
}

function stripSlash(
  path: string,
): string {
  return path.replace(/^\//, "");
}

export const routes: Routes = [
  {
    path: stripSlash(environment.paths.boardButton),
    component: BoardButtonCallbackComponent,
    canActivate: [IframeOriginGuard],
  },
  {
    path: stripSlash(environment.paths.oauthCallback),
    component: OauthCallbackComponent,
    canActivate: [IframeOriginGuard],
  },
  {
    path: '',
    providers: providers,
    component: PageLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: stripSlash(environment.paths.configuration),
        component: ConfigurationComponent,
        canActivate: [AuthenticationGuard],
        data: {selectedPage: lastSegment(environment.paths.configuration)},
      },
      {
        path: stripSlash(environment.paths.help),
        component: HelpComponent,
        canActivate: [AuthenticationGuard],
        data: {selectedPage: lastSegment(environment.paths.help)},
      },
      {
        path: stripSlash(environment.paths.home),
        component: HomeComponent,
        canActivate: [AuthenticationGuard],
        data: {selectedPage: lastSegment(environment.paths.home)},
      },
      {
        path: stripSlash(environment.paths.onboarding),
        component: OnboardingComponent,
        canActivate: [IframeOriginGuard],
        data: {selectedPage: lastSegment(environment.paths.onboarding)},
      },
      {
        path: stripSlash(environment.paths.reportBoardSummary),
        component: BoardSummaryComponent,
        canActivate: [AuthenticationGuard],
        data: {selectedPage: lastSegment(environment.paths.reportBoardSummary)},
      },
      {
        path: stripSlash(environment.paths.reportBoardSummaryReference),
        component: BoardSummaryReferenceComponent,
        canActivate: [AuthenticationGuard],
        data: {selectedPage: lastSegment(environment.paths.reportBoardSummaryReference)},
      },
      {
        path: stripSlash(environment.paths.reportCardDetails),
        component: CardDetailsComponent,
        canActivate: [AuthenticationGuard],
        data: {selectedPage: lastSegment(environment.paths.reportCardDetails)},
      },
      {
        path: stripSlash(environment.paths.reportMemberActivity),
        component: MemberActivityComponent,
        canActivate: [AuthenticationGuard],
        data: {selectedPage: lastSegment(environment.paths.reportMemberActivity)},
      },
      {
        path: stripSlash(environment.paths.reportTimeTracking),
        component: TimeTrackingComponent,
        canActivate: [AuthenticationGuard],
        data: {selectedPage: lastSegment(environment.paths.reportTimeTracking)},
      },
      {
        path: stripSlash(environment.paths.cardChat),
        component: CardChatComponent,
        canActivate: [AuthenticationGuard],
        data: {selectedPage: lastSegment(environment.paths.cardChat)},
      },
    ],
  },
];
